export const AccessPermissions = {
  ['read_write_policies']: 97n,
  ['read_write_site_groups']: 98n,
  ['read_write_users']: 99n,
  ['write_access_rules_to_users']: 100n,
} as const

export type AccessPermissionsKey = keyof typeof AccessPermissions
